/**
 * SaasSurfaceOutlet — renders the matched saas-ai page, keyed by vendor+surface.
 *
 * Changing the Claude surface (?surface=chat|code|cowork) only changes a query
 * param, which React Router does NOT treat as a navigation, so pages wouldn't
 * re-fetch. Keying the wrapper on `${vendor}:${surface}` forces the subtree to
 * remount on a surface (or vendor) switch, so every page re-runs its initial
 * fetch with the new filter — no per-page wiring needed. `display: contents`
 * keeps the wrapper out of layout.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';

import { useSaasVendor } from '../../contexts/SaasVendorContext';

export default function SaasSurfaceOutlet() {
  const { vendor, surface } = useSaasVendor();
  return (
    <div key={`${vendor}:${surface}`} style={{ display: 'contents' }}>
      <Outlet />
    </div>
  );
}
